(function () {
  const lang =
    document.documentElement.lang ||
    (window.Shopify && Shopify.locale);

  if (!lang || !lang.toLowerCase().startsWith('de')) return;

  const labels = {
    offerName: 'Name',
    offerEmail: 'E-Mail Adresse',
    offerAmount: 'Ihr Preisvorschlag',
  };

  const placeholders = {
    offerAmount: 'Ihr Preisvorschlag',
    customerEmail: 'E-Mail Adresse',
    customerName: 'Name',
  };
  
  Object.entries(labels).forEach(([forAttr, text]) => {
    const label = document.querySelector(
      `label.offerly-input-label[for="${forAttr}"]`
    );
    if (label) {
      label.textContent = text;
    }
  });
  Object.entries(placeholders).forEach(([name, text]) => {
    document
      .querySelectorAll(`input.offerInput[name="${name}"]`)
      .forEach(input => {
        input.placeholder = text;
      });
  });
})();
